const boo = () => {

  if (process.env.NODE_ENV === 'prod') {
    return ''

  } else if (process.env.NODE_ENV === 'pre') {
    //预发
    return '-pre'

  } else {
    return '-dev'
  } 
}
export {
  boo
}

// const boo = () =>  {
//   return ''
// }
// export {
//   boo
// }



// WEBPACK FOOTER //
// ./src/tool/apiboo.js